import React from "react";

function Download({ width = 16, height = 16, fill = "currentColor", className = "" }) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.69L6.53 8.72a.75.75 0 0 0-1.06 1.06l4.25 4.25a.75.75 0 0 0 1.06 0l4.25-4.25a.75.75 0 1 0-1.06-1.06l-2.72 2.72V2.75Z" />
      <path d="M3.5 14.75a.75.75 0 0 0-1.5 0v1.5A2.25 2.25 0 0 0 4.25 18.5h11.5A2.25 2.25 0 0 0 18 16.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 1-.75.75H4.25a.75.75 0 0 1-.75-.75v-1.5Z" />
    </svg>
  );
}

export default Download;
